"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocalizedRegionDisplayName = void 0;

function getLocalizedRegionDisplayName(regionCode, locale) {
  var IntlDisplayNames = new Intl.DisplayNames([locale], {
    type: 'region'
  });
  return IntlDisplayNames.of(regionCode);
}

exports.getLocalizedRegionDisplayName = getLocalizedRegionDisplayName;